import React, { Component, PropTypes } from 'react';
import { mixin, RefluxMixin } from 'Util';
import AuthStore from 'stores/Auth';
import AppStore from 'stores/App';
import { addMessages } from 'oxygen-i18n';
import i18n from 'oxygen-i18n';
import { Typography, Colors } from 'Css';
import AppSnackBar from 'components/AppSnackBar';
import MessagePortal from 'components/MessagePortal';

// if (!__DEV__) {
// i18n.fallback = false;
// }

try {
  const messages = require('../../locale/messages.json');
  addMessages(messages);
} catch (e) {
  // Nothing going on
}

class CoursioApp extends Component {
  static propTypes = {
    children: PropTypes.node,
    locale: PropTypes.string
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.locale !== nextProps.locale) {
      const { locale } = nextProps;
      i18n.setLocale(locale.replace('_', '-'), locale.replace('_', '-'));
      this.forceUpdate();
    }
  }

  render() {
    return <div>{this.props.children}</div>;
  }
}

class CoursioAppContainer extends mixin(RefluxMixin, Component) {
  static childContextTypes = {
    user: PropTypes.object
  };

  listenToStores() {
    this.listenToStoreWithMapper(AuthStore, state => {
      return {
        loggedIn: state.loggedIn,
        name: state.displayName,
        email: state.email,
        createdAt: state.createdAt,
        user: state,
        role: state.role,
        locale: state.locale
      };
    });
    this.listenToStoreWithMapper(AppStore, state => {
      return {
        message: state.message
      };
    });
  }

  getChildContext() {
    return {
      user: this.state.user
    };
  }

  render() {
    const { children } = this.props;
    const {
      locale,
      message,
    } = this.state;
    return (
      <CoursioApp locale={locale}>
        {children}
        <MessagePortal>
          <AppSnackBar {...message} />
        </MessagePortal>
      </CoursioApp>
    );
  }
}

export default CoursioAppContainer;



// WEBPACK FOOTER //
// ./src/js/containers/CoursioAppContainer.js